import { useMutation, useQueryClient } from '@tanstack/react-query';
import { replyToReview, deleteReviewReply } from '../services/my-reviews.service';

export function useReplyToReview() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, text }: { id: string; text: string }) => replyToReview(id, text),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['my-reviews'] }),
  });
}

export function useDeleteReviewReply() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => deleteReviewReply(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['my-reviews'] }),
  });
}
